import './test.scss';
import { TestChart } from '../testChart/testChart.component.js';
import { getTestByCode, getTestBySlug } from '../../services/test.service.js';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { message, Spin } from 'antd';
import UtilHelper  from '../../helpers/util.helper.js';
import PanelDetail from '../panelDetail/panelDetail.component.js';
import PosthogHelper from '../../helpers/posthog.helper.js';
import { UserContext } from '../../contexts/user.context.js';
import { useContext } from 'react';

export const Test = () => {
  const { code } = useParams();
  const [test, setTest] = useState(null);
  const [panel, setPanel] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useContext(UserContext);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  useEffect(() => {

    if (!test && !panel) {
      return;
    }

    if (test) {
      document.title = `${test?.shortName && test?.longName ? `${test?.longName} (${test?.shortName})` : test?.name} | Instalab`;
      document.description = test?.tagline;
    }

    if (panel) {
      document.title = `${panel?.shortName && panel?.longName ? `${panel?.longName} (${panel?.shortName})` : panel?.name} | Instalab`;
      document.description = panel?.tagline;
    }

  }, [test, panel]);


  useEffect(() => {
    if (currentUser && test) {
      PosthogHelper.track(currentUser, `[test] ${test?.name} view landing`, true)
    }
    if (currentUser && panel) {
      PosthogHelper.track(currentUser, `[panel] ${panel?.name} view landing`, true)
    }
  }, [currentUser, test, panel])

  useEffect(() => {
    if (!code) return;

    const fetchTest = async () => {
      try {
        if (UtilHelper.isNumber(code)) {
          const currentTest = await getTestByCode(code);
          if (currentTest) {
            setTest(currentTest);
            return;
          }
        }

        else {
          const response = await getTestBySlug(code);
          if (response) {
            if (response.isPanel) {
              setPanel(response.panel);
              return;
            }
            else {
              setTest(response);
              return;
            }
          }
        }
 
      } catch (error) {
        console.error('Error fetching test:', error);
        message.error('Could not find test');
      } finally {
        setLoading(false);
      }
    };

    fetchTest();
  }, [code]); 


  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
        <p>One Moment Please<br/>Loading Test</p>
      </div>
    );
  }


  return (
    <div className="test-page">
      <div className="test-page-chart-container">
        {test && <TestChart key={test._id} id={test._id} setAnnotations={() => {}} />}
        {panel && <PanelDetail key={panel._id} panel={panel} isMobileView={isMobileView} />}
      </div>
    </div>
  );
};

export default Test;